import { css } from "styled-components";
import token from "styled-token";
import { typographyMixin } from "../typographyMixin";
/** @class GleamMixin */

/** @method */

export var GleamMixin = function GleamMixin(props) {
  return token({
    fontType: "Gleam.fontType",
    backgroundColor: "Gleam.backgroundColor",
    borderRadius: "radii.pill",
    color: "Gleam.fontColor",
    height: "Gleam.height",
    padding: "Gleam.padding"
  }, function (_ref) {
    var fontType = _ref.fontType,
        backgroundColor = _ref.backgroundColor,
        borderRadius = _ref.borderRadius,
        color = _ref.color,
        height = _ref.height,
        padding = _ref.padding;
    return css(["", " display:inline-block;background:", ";border-radius:", ";color:", ";height:", "px;line-height:", "px;padding-left:", "px;padding-right:", "px;"], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), backgroundColor, borderRadius, color, height, height, padding, padding);
  })(props);
};